import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const TruckLocation = ({ carLocation }: SpecProps<"car_location">) => {
  const { i18n } = useLingui();

  if (!carLocation) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.truck.location",
    message: "Vehicle location",
    comment: "Field for 'Vehicle location for truck' in ad specification",
  });
  return <FieldValuePair field={field} value={carLocation} />;
};
